"use strict";
// Fase 17.3, Plano 10 (D-09..D-12): avisos do consumo previsto de tinta na liberação da OP.
// Os rótulos em pt-BR ficam no helper da web (apps/web/src/lib/roteiros/consumo-tinta.ts), não aqui.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVISOS_CONSUMO_TINTA = void 0;
/** Códigos que o servidor devolve em `avisosConsumo` do preflight; nenhum bloqueia a liberação. */
exports.AVISOS_CONSUMO_TINTA = [
    'SEM_AREA',
    'SEM_COR',
    'SEM_TINTA_CADASTRADA',
    'SEM_RENDIMENTO',
    /** A conta usou o rendimento padrão do tipo; não é dado faltando e não bloqueia a liberação. */
    'RENDIMENTO_ESTIMADO',
    'TINTA_AMBIGUA',
    'CONSUMO_ARREDONDADO_ZERO',
    /** A OP não tem quantidade (entrada do lote zerada ou saldo devolvido igual/maior): o consumo por peça não pode ser calculado. */
    'OP_SEM_QUANTIDADE',
];
//# sourceMappingURL=roteiros-consumo.js.map